import { Form, Input } from "antd";
import React from "react";

const CardioRespiratoryArrest = () => {
  return (
    <>
      <Form.Item
        name={["comments", "comments"]}
        label="Cardio Respiratory Arrest"
      >
        <Input.TextArea rows={2} placeholder="Cause of Death / Comments" />
      </Form.Item>
    </>
  );
};

export default CardioRespiratoryArrest;
